module.exports = __webpack_public_path__ + "static/media/ehealth_pro_acc_p3_1.b3fb0aed.png";